import React, { useState, useEffect } from "react";
import ValidatedImage from "../../utils/ValidatedImage"
import PassportDialog from "./PassportDialog/PassportDialog"
import { CircularProgress } from '@material-ui/core';
import axios from "axios";
import { useTranslation } from "react-i18next";

function PassportCard(props){

    const { t } = useTranslation()

    const { passport } = props

    const [OCR, setOCR] = useState(null)
    const [OCRFront, setOCRFront] = useState(null)
    const [OCRBack, setOCRBack] = useState(null)
    const [OCRFileType, setOCRFileType] = useState(null)
    const [OCRPictureOpen, setOCRPictureOpen] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (passport.ocr_front_key) {
                axios.get('/dash/ocr/' + passport.ocr_front_key).then( response => {
                    let ocr_data_front = response.data.processed_object 
                    if (ocr_data_front == null) throw new Error()
                    setOCRFront(ocr_data_front);             
                }).catch(error => {
                    setOCRFront(undefined)
                })
            }
            if (passport.ocr_back_key) {
                axios.get('/dash/ocr/' + passport.ocr_back_key).then( response => {
                    let ocr_data_back = response.data.processed_object 
                    if (ocr_data_back == null) throw new Error()
                    setOCRBack(ocr_data_back);             
                }).catch(error => {
                    setOCRBack(undefined)
                })
            }
        }, 500);
        return () => {
            clearTimeout(timer)
        }
    }, [passport])

    useEffect(() => {
        const timer = setTimeout(() => {
            if (passport.ocr_front_key) {
                axios.get('/dash/ocr/' + passport.ocr_front_key).then( response => {
                    let hasPDF = response.data.pdf
                    if (hasPDF) {
                        setOCRFileType("pdf");
                    } else {
                        setOCRFileType("image");
                    }
                    let ocr_data_front = response.data.processed_object 
                    if (ocr_data_front == null) throw new Error()
                    setOCRFront(ocr_data_front);             
                }).catch(error => {
                    setOCRFront(undefined)
                })
            }

            if (passport.ocr_back_key) {
                axios.get('/dash/ocr/' + passport.ocr_back_key).then( response => {
                    let hasPDF = response.data.pdf
                    if (hasPDF) {
                        setOCRFileType("pdf");
                    } else {
                        setOCRFileType("image");
                    }
                    let ocr_data_back = response.data.processed_object 
                    if (ocr_data_back == null) throw new Error()
                    setOCRBack(ocr_data_back);             
                }).catch(error => {
                    setOCRBack(undefined)
                })
            }
        }, 500);
        return () => {
            clearTimeout(timer)
        }
    }, [passport])

    useEffect(() => {
        if (OCRFront !== null || OCRBack!== null){
            if (OCRFront && OCRBack) {
                let ocr_data_joined = {...OCRFront,...OCRBack}
                setOCR(ocr_data_joined)
                }
            else if (OCRFront) setOCRFront(OCRFront)
            else if (OCRBack)  setOCRBack(OCRBack)
            else setOCR(undefined)
        }
    },[OCRFront, OCRBack])

    let getPictureContent = (picture) => {
        if (picture === undefined) {
            return (          
                <div 
                    className={["labelText", "normalMediumSize"].join(" ")} 
                    style={{textAlign:"center", margin:"auto"}}
                >
                    {t("information_unavailable")}
                </div>
            )
        } 
        else{
            return (
                <ValidatedImage
                    image_key={picture}
                    dash_api_endpoint_url={'/dash/ocr/image'}
                    imageStyle = {{margin:"auto", width:"100%", height:"100%",position:"absolute", top:"-9999px",bottom:"-9999px",left:"-9999px",right:"-9999px", borderRadius: "5px", objectFit:"cover"}}
                    imageAlt = {"Foto do Documento"}
                    fileType={OCRFileType}
                />
            );
        }
    };

    if (OCR === null || OCRFileType===null) {
        return (
            <div style={{minHeight: "250px"}} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("Passaporte OCR")}</div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <CircularProgress style={{margin:"auto"}} />
                </div>
            </div>
        );    
    }
    else if (OCR === undefined || OCRFileType===undefined){
        return (
            <div style={{minHeight: "250px"}} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("Passaporte OCR")}</div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <div className={["labelText", "normalMediumSize"].join(" ")} style={{margin:"auto"}}>
                        {t("information_unavailable")}
                    </div>
                </div>
            </div>
        )
    }
    else {
        return (
            <div style={{minHeight: "600px", width:"100%"}} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("Passaporte OCR")}</div>
                <div className="internalCardContainer" style={{display:"flex", flexGrow:"1", maxHeight:"600px",flexDirection: "row", width:"100%"}}>
                    <div style={{display:"flex", maxHeight:"64vw", flexDirection: "column", width:"100%"}}>
                        <div style={{display:"block", width:"100%", height:"90%", margin: "0 auto", overflow:"hidden", position:"relative", alignItems: "center", justifyContent: "center",borderRadius: "5px"}}>
                            {passport.ocr_front_key && getPictureContent(passport.ocr_front_key)}
                        </div>
                        {(passport.ocr_front_key || passport.ocr_back_key)&&
                        <div 
                            onClick={()=>setOCRPictureOpen(true)}
                            className={["blueText", "normalSmallSize", "link"].join(" ")} 
                            style={{margin:"10px", textAlign:"center"}}
                        >
                            {`${t("see")} ${t(OCRFileType)}`}
                        </div>}
                    </div>
                    {(passport.ocr_front_key || passport.ocr_back_key)&&
                        <PassportDialog
                            open={OCRPictureOpen}
                            onClose={()=>setOCRPictureOpen(false)}
                            image_list={[passport.ocr_front_key, passport.ocr_back_key]}
                            fileType={OCRFileType}
                    />}
                </div>
            </div>
        );
    }
}

export default PassportCard